// @ts-ignore
export function IubendaComp({content}) {
    return (
        <div>
            <div className="bg-gray-50 overflow-hidden py-4">
                <div className="relative max-w-prose mx-auto py-12 px-4 sm:px-6 lg:px-8">
                    <div  className="relative h-full prose text-gray-600 mx-auto" dangerouslySetInnerHTML={{__html: content}} />
                </div>
            </div>
        </div>
    )
}

